module.exports = __webpack_public_path__ + "img/comitentes.cc3b3a8b.svg";